import { useEffect } from "react";

const DEFAULT_DESCRIPTION =
  "Wara Cards digitalise votre fidélité client : carte dans le wallet en 2 clics, notifications push, prise de RDV, avis clients et analytics.";

interface PageMetaOptions {
  /** The complete tab title for this page, e.g. "Mentions légales — Wara Cards". */
  title: string;
  description?: string;
  /** Set true for private/utility pages that shouldn't appear in search results. */
  noindex?: boolean;
}

function setMetaTag(name: string, content: string) {
  let tag = document.querySelector(`meta[name="${name}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("name", name);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

function setOgTag(property: string, content: string) {
  let tag = document.querySelector(`meta[property="${property}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute("property", property);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

/** Sets a unique document title + meta description (+ OG tags) per route. */
export function usePageMeta({ title, description, noindex }: PageMetaOptions) {
  useEffect(() => {
    const desc = description ?? DEFAULT_DESCRIPTION;

    document.title = title;
    setMetaTag("description", desc);
    setMetaTag("robots", noindex ? "noindex, nofollow" : "index, follow");
    setOgTag("og:title", title);
    setOgTag("og:description", desc);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${window.location.origin}${window.location.pathname}`);
  }, [title, description, noindex]);
}
